
import HttpClient from "@api/clients/httpClient";
import { Filter } from "@api/models/HttpClientModels";
import Registration from "../models/Registration";

const config = {
    endpoint: "users",
};

export default class RegistrationService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new Filter());
    }

    registerAsync = async (userToRegister: Registration) => {
        return await this.httpClient.postAsync<Registration[]>(userToRegister);
    };
    checkEmailAddressAsync = async (emailAddress: string) => {
        return await this.httpClient.postAsync(emailAddress, "email-check")
      }
}